import React from 'react'

import {useFeatureEntitlement} from '~/entitlement/use-feature-entitlement'
import * as tracking from '~/tracking'

export function useSupportChat() {
    const [isConnected, setIsConnected] = React.useState(false)
    const [isActive, setIsActive] = React.useState(false)
    const {isEntitled} = useFeatureEntitlement('LIVE_CHAT_SUPPORT')

    React.useEffect(() => {
        // A way to determine intercom is initialised or not. This is needed for adblocks that completely prevent Intercom from being initialised
        // https://forum.intercom.com/s/question/0D52G00004WxWMg/how-can-i-check-if-an-adblocker-has-prevented-the-messenger-script-from-loading
        window.Intercom?.('onUnreadCountChange', () => {
            setIsConnected(true)
        })
    }, [])

    const hide = React.useCallback(() => {
        window.Intercom?.('hide')
        setIsActive(false)
    }, [])

    const onShow = React.useCallback((handler: () => void) => {
        window.Intercom?.('onShow', handler)
    }, [])

    const onHide = React.useCallback((handler: () => void) => {
        window.Intercom?.('onHide', handler)
    }, [])

    const show = React.useCallback(() => {
        if (!isConnected) {
            return
        }
        setIsActive(true)
        window.Intercom?.('show')
        tracking.supportChatOpened()
    }, [isConnected])

    const logout = React.useCallback(() => {
        if (!isConnected) {
            return
        }
        window.Intercom?.('shutdown')
    }, [isConnected])

    return {
        isActive,
        setIsActive,
        isConnected,
        hide,
        show,
        onShow,
        onHide,
        logout,
        isEntitled,
    }
}
